import React from 'react';
import { Box, VStack, Heading, Text, Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const IndexPage = () => {
  return (
    <Box bg="gray.900" color="white" minHeight="100vh" p={10}>
      <VStack spacing={8} justifyContent="center" alignItems="center" height="100%">
        <Heading as="h1" size="2xl" mb={6}>
          Eldritch Index
        </Heading>
        <Text fontSize="xl" textAlign="center">
          Choose your path and delve into the unknown. Each choice leads further into the abyss.
        </Text>
        <VStack spacing={5}>
          <Link to="/gallery">
            <Button colorScheme="teal">Cosmic Horrors Gallery</Button>
          </Link>
          <Link to="/quiz">
            <Button colorScheme="teal">Forbidden Knowledge Quiz</Button>
          </Link>
          <Link to="/story">
            <Button colorScheme="teal">Interactive Storytelling</Button>
          </Link>
          <Link to="/3d">
            <Button colorScheme="teal">3D Visuals</Button>
          </Link>
          <Link to="/puzzle">
            <Button colorScheme="teal">Puzzle</Button>
          </Link>
          <Link to="/madness">
            <Button colorScheme="teal">Madness Meter</Button>
          </Link>
        </VStack>
      </VStack>
    </Box>
  );
};

export default IndexPage;
